import {
  CHANGE_USER_EMAIL,
  CHANGE_USER_EMAIL_SUCCESS,
  CHANGE_USER_EMAIL_FAILURE,
  RESET_CHANGE_USER_EMAIL_STATE,
  SET_CHANGE_USER_EMAIL_LOADING,
  CHANGE_USER_EMAIL_DO_SHOW_LOG,
  CHANGE_USER_EMAIL_LOG_CHANGE_PAGE,
  CHANGE_USER_EMAIL_LOG_SET_SHOWN,
  CHANGE_USER_EMAIL_LOG_SET_DATA,
  CHANGE_USER_EMAIL_LOG_SET_IS_LOADING,
  CHANGE_USER_EMAIL_LOG_SET_ERRORS,
} from 'state/actionTypes';

export const changeUserEmail = payload => ({
  type: CHANGE_USER_EMAIL,
  payload,
});

export const changeUserEmailSuccess = data => ({
  type: CHANGE_USER_EMAIL_SUCCESS,
  payload: data,
});

export const changeUserEmailFailure = error => ({
  type: CHANGE_USER_EMAIL_FAILURE,
  payload: error,
});

export const setChangeUserEmailLoading = isLoading => ({
  type: SET_CHANGE_USER_EMAIL_LOADING,
  payload: isLoading,
});

export const resetChangeUserEmailState = () => ({
  type: RESET_CHANGE_USER_EMAIL_STATE,
});

export const setChangeUserEmailLogModalShown = shown => ({
  type: CHANGE_USER_EMAIL_LOG_SET_SHOWN,
  payload: { shown },
});

export const doShowChangeUserEmailLogs = () => ({
  type: CHANGE_USER_EMAIL_DO_SHOW_LOG,
});

export const setChangeUserEmailLogPage = page => ({
  type: CHANGE_USER_EMAIL_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setChangeUserEmailLogData = (data, paging) => ({
  type: CHANGE_USER_EMAIL_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetChangeUserEmailLogData = () =>
  setChangeUserEmailLogData([], { page: 1, size: 20, total: 0 });

export const setChangeUserEmailLogIsLoading = isLoading => ({
  type: CHANGE_USER_EMAIL_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setChangeUserEmailLogErrors = errors => ({
  type: CHANGE_USER_EMAIL_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearChangeUserEmailLogErrors = () =>
  setChangeUserEmailLogErrors([]);
